import analytics from './analytics';
var DESTINATION_PAGE_NAME = 'premier inn: seo: hotels in';
var updateDestinationPageAnalytics = _ref => {
  var _thingsToDo$items$map, _thingsToDo$items, _promos$map;
  var locationName = _ref.locationName,
    hotelDisplayedCount = _ref.hotelDisplayedCount,
    destinations = _ref.destinations,
    hotels = _ref.hotels,
    filterType = _ref.filterType,
    thingsToDo = _ref.thingsToDo,
    mapReference = _ref.mapReference,
    premierPlusLabel = _ref.premierPlusLabel,
    promos = _ref.promos;
  var hotelsAnalytics = hotels.map((hotel, i) => {
    var _hotel$hotelFacilitie, _hotel$messagingFlag, _hotel$tripAdvisorRev, _hotel$tripAdvisorRev2;
    var hotelLabels = [];
    if ((_hotel$hotelFacilitie = hotel.hotelFacilities) !== null && _hotel$hotelFacilitie !== void 0 && _hotel$hotelFacilitie.find(facility => facility.code === 'PRR')) {
      hotelLabels.push(premierPlusLabel);
    }
    if ((_hotel$messagingFlag = hotel.messagingFlag) !== null && _hotel$messagingFlag !== void 0 && _hotel$messagingFlag.text && hotel.messagingFlag.text != 'hub') {
      hotelLabels.push(hotel.messagingFlag.text);
    }
    return {
      hotelName: hotel.name,
      hotelCode: hotel.hotelId,
      orderPosition: i + 1,
      hotelLabels,
      tripAdvisorRating: (_hotel$tripAdvisorRev = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev === void 0 ? void 0 : _hotel$tripAdvisorRev.rating,
      tripAdvisorReviewsCount: (_hotel$tripAdvisorRev2 = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev2 === void 0 ? void 0 : _hotel$tripAdvisorRev2.numberOfReviews
    };
  });
  var destinationsListAnalytics = destinations === null || destinations === void 0 ? void 0 : destinations.map((destination, i) => ({
    destinationLocationName: destination.title,
    destinationPosition: i + 1
  }));
  var analyticsThingsToDo = (_thingsToDo$items$map = thingsToDo === null || thingsToDo === void 0 || (_thingsToDo$items = thingsToDo.items) === null || _thingsToDo$items === void 0 ? void 0 : _thingsToDo$items.map(toDo => ({
    tileName: toDo.title,
    tilePosition: toDo.order
  }))) !== null && _thingsToDo$items$map !== void 0 ? _thingsToDo$items$map : [];
  var analyticsTravelGuides = (_promos$map = promos === null || promos === void 0 ? void 0 : promos.map(promo => ({
    tileName: promo.title,
    tilePosition: promo.order
  }))) !== null && _promos$map !== void 0 ? _promos$map : [];
  var dlpAnalytics = {
    locationName,
    hotelDisplayedCount,
    destinations: destinationsListAnalytics,
    hotels: hotelsAnalytics,
    filterType,
    thingsToDo: analyticsThingsToDo,
    travelGuides: analyticsTravelGuides,
    mapReference,
    filterSectionOpened: false,
    filtersCleared: false,
    searchFilter: ''
  };
  return analytics.update({
    pageName: "".concat(DESTINATION_PAGE_NAME, " ").concat(locationName),
    dlp: dlpAnalytics
  });
};
export default updateDestinationPageAnalytics;